import { useEffect, useMemo } from "react";
import { useFetchData } from "../../useFetch/post";
import type { UseAttrsType } from "./useAttrsType";
import type { IAttrsData } from "../../../components/tabs/analysisAgent/UseFetchType";

export const useAttrs = ({
  classNames,
  operation,
  enabled = true,
  messageApi,
}: UseAttrsType) => {
  const sortedSelect = useMemo(
    () => (data: { items: IAttrsData[] }) =>
      [...(data?.items ?? [])].sort((a, b) =>
        a.attr_code.localeCompare(b.attr_code),
      ),
    [],
  );

  const [fetchAttributes, { data: attributes, isLoading, error, clearError }] =
    useFetchData<IAttrsData[]>({
      query: "/classes/attributes",
      selectData: sortedSelect,
    });

  useEffect(() => {
    if (!enabled) return;
    fetchAttributes({ operation }, classNames);
  }, [enabled, operation, classNames]);

  useEffect(() => {
    if (error) {
      messageApi.error(error.message);
      clearError?.();
    }
  }, [error, messageApi]);

  return {
    attributes,
    isLoading,
  };
};
